<div class="edit-info">
    <div class="edit-info__wrapper">
      <div class="edit-info__wrapper--inner">
        <div class="edit-info__container">
          <div class="edit-info__content">

            <div>
              <rad-banner-notification
                *ngIf="showErrorMessageBanner"
                class="rad-theme--light"
                variant="error"
                [attr.dismissible]="false"
                >
                    <span slot="content">
                        {{errorMsg}}
                    </span>
                </rad-banner-notification>

            </div>

            <div class="edit-info__edit-list" *ngIf="editableFields.length > 0">
              <div class="edit-info__result__item" *ngFor="let item of editableFields; let i = index">

                <div class="input-field" *ngIf="item.type === InputFieldType.INPUT">
                  <rad-text-field
                  class="rad-theme--light"
                  [(ngModel)]="item.currentValue"
                  (onInput)="onChangeInputValues($event)"
                  [attr.label]="item.name"
                  [attr.minlength]="!item.isOptional ? '1' : null"
                  [attr.maxlength]="item.maxLength?.toString()"
                  [attr.placeholder]="item.placeholder"
                  [attr.error]="getEditableFieldError(item).length > 0"
                  [attr.errormsg]="getEditableFieldError(item)"
                  [attr.disabled]="item.disabled"
                  ></rad-text-field>
                </div>

                <div class="input-field input-field--block" *ngIf="item.type === InputFieldType.TEXTAREA">
                  <rad-textarea
                    class="rad-theme--light"
                    (onInput)="onChangeInputValues($event)"
                    [(ngModel)]="item.currentValue"
                    [attr.label]="item.name"
                    [attr.minlength]="!item.isOptional ? '1' : null"
                    [attr.maxlength]="item.maxLength?.toString()"
                    [attr.placeholder]="item.placeholder"
                    [attr.error]="getEditableFieldError(item).length > 0"
                    [attr.errormsg]="getEditableFieldError(item)"
                    [attr.disabled]="item.disabled"
                    rows="4"
                    ></rad-textarea>

                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </div>
</div>
  